export { IconSVG } from './icon-svg';
